/* note: this is a straight rip-off from angular-material.js, but with all all the references to the input removed */

meedy.directive('datePickerButton', [
    function() {
        var definition = {
            restrict: 'E',
            require: ['ngModel', 'datePickerButton'],
            scope: {
                minDate: '=mdMinDate',
                maxDate: '=mdMaxDate',
                dateFilter: '=mdDateFilter',
                onDateChange: '&'
            },
            templateUrl: 'meedy/application/directive/datePickerButton/template/date-picker-button.html',
            controller: DatePickerCtrl,
            controllerAs: 'ctrl',
            bindToController: true,
            link: function(scope, element, attr, controllers) {
                var ngModelCtrl = controllers[0];
                var mdDatePickerCtrl = controllers[1];
                mdDatePickerCtrl.configureNgModel(ngModelCtrl);
            }
        };

        return definition;
    }
]);

function DatePickerCtrl($scope, $element, $attrs, $compile, $timeout, $window, $mdConstant, $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF) {

    this.CALENDAR_PANE_HEIGHT = 368;
    this.CALENDAR_PANE_WIDTH = 360;

    this.$compile = $compile;
    this.$timeout = $timeout;
    this.$window = $window;
    this.dateLocale = $mdDateLocale;
    this.dateUtil = $$mdDateUtil;
    this.$mdConstant = $mdConstant;
    this.$mdUtil = $mdUtil;
    this.$$rAF = $$rAF;

    this.documentElement = angular.element(document.documentElement);

    this.ngModelCtrl = null;

    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');
    this.calendarButton = $element[0].querySelector('.md-datepicker-button');
    this.$element = $element;

    this.$attrs = $attrs;
    this.$scope = $scope;
    this.date = null;

    this.isDisabled;
    this.setDisabled($element[0].disabled || angular.isString($attrs['disabled']));

    this.isCalendarOpen = false;

    this.calendarPaneOpenedFrom = null;
    this.calendarPane.id = 'md-date-pane' + $mdUtil.nextUid();

    $mdTheming($element);

    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);
    this.windowResizeHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();

    var self = this;
    $scope.$on('$destroy', function() {
        self.detachCalendarPane();
    });
}

DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$compile", "$timeout", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF"];

DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl) {
    this.ngModelCtrl = ngModelCtrl;

    var self = this;
    ngModelCtrl.$render = function() {
        var value = self.ngModelCtrl.$viewValue;

        if (value && !(value instanceof Date)) {
            throw Error('The ng-model for md-datepicker must be a Date instance. ' +
                'Currently the model is a: ' + (typeof value));
        }

        self.date = value;
        self.updateErrorState();
    };
};

DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-change', function(event, date) {
        self.ngModelCtrl.$setViewValue(date);
        self.date = date;
        self.onDateChange({date: date});
        self.closeCalendarPane();
        self.updateErrorState();
    });
};

DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    $scope.$on('md-calendar-close', function() {
        self.closeCalendarPane();
    });
};

DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs['ngDisabled']) {
        var scope = this.$mdUtil.validateScope(this.$element) ? this.$element.scope() : null;

        if (scope) {
            scope.$watch(this.$attrs['ngDisabled'], function(isDisabled) {
                self.setDisabled(isDisabled);
            });
        }
    }
};

DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.calendarButton.disabled = isDisabled;
};

DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date = opt_date || this.date;

    this.clearErrorState();

    if (this.dateUtil.isValidDate(date)) {
        if (this.dateUtil.isValidDate(this.minDate)) {
            this.ngModelCtrl.$setValidity('mindate', date >= this.minDate);
        }

        if (this.dateUtil.isValidDate(this.maxDate)) {
            this.ngModelCtrl.$setValidity('maxdate', date <= this.maxDate);
        }

        if (angular.isFunction(this.dateFilter)) {
            this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
        }
    } else {
        this.ngModelCtrl.$setValidity('valid', date == null);
    }
};

DatePickerCtrl.prototype.clearErrorState = function() {
    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
        this.ngModelCtrl.$setValidity(field, true);
    }, this);
};

DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
        (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
};

DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    calendarPane.style.transform = '';
    this.$element.addClass('md-datepicker-open');

    var elementRect = this.calendarButton.getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();

    var paneTop = elementRect.top - bodyRect.top;
    var paneLeft = elementRect.left - bodyRect.left;

    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ? -bodyRect.top : document.body.scrollTop;
    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ? -bodyRect.left : document.body.scrollLeft;
    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    if (paneLeft + this.CALENDAR_PANE_WIDTH > viewportRight) {
        if (viewportRight - this.CALENDAR_PANE_WIDTH > 0) {
            paneLeft = viewportRight - this.CALENDAR_PANE_WIDTH;
        } else {
            paneLeft = viewportLeft;
            var scale = this.$window.innerWidth / this.CALENDAR_PANE_WIDTH;
            calendarPane.style.transform = 'scale(' + scale + ')';
        }

        calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    if (paneTop + this.CALENDAR_PANE_HEIGHT > viewportBottom &&
        viewportBottom - this.CALENDAR_PANE_HEIGHT > viewportTop) {
        paneTop = viewportBottom - this.CALENDAR_PANE_HEIGHT;
        calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    calendarPane.style.left = paneLeft + 'px';
    calendarPane.style.top = paneTop + 'px';
    document.body.appendChild(calendarPane);

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
        calendarPane.classList.add('md-pane-open');
    });
};

DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass('md-datepicker-open');
    this.calendarPane.classList.remove('md-pane-open');
    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

    if (this.calendarPane.parentNode) {
        this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
};

DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled) {
        this.isCalendarOpen = true;
        this.calendarPaneOpenedFrom = event.target;

        this.$mdUtil.disableScrollAround(this.calendarPane);

        this.attachCalendarPane();
        this.focusCalendar();

        var self = this;
        this.$mdUtil.nextTick(function() {
            self.documentElement.on('click touchstart', self.bodyClickHandler);
        }, false);

        window.addEventListener('resize', this.windowResizeHandler);
    }
};

DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
        this.isCalendarOpen = false;
        this.detachCalendarPane();
        // this.calendarPaneOpenedFrom.focus();
        this.calendarPaneOpenedFrom = null;
        this.$mdUtil.enableScrolling();

        this.documentElement.off('click touchstart', this.bodyClickHandler);
        window.removeEventListener('resize', this.windowResizeHandler);
    }
};

DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
};

DatePickerCtrl.prototype.focusCalendar = function() {
    var self = this;
    this.$mdUtil.nextTick(function() {
        self.getCalendarCtrl().focus();
    }, false);
};

DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
        var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
        if (!isInCalendar) {
            this.closeCalendarPane();
        }

        this.$scope.$digest();
    }
};